var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export var getDirectiveArgumentValueFromOperation = function (operation, directiveName, argumentName) {
    var _a, _b, _c, _d, _e, _f;
    return (_f = (_e = (_d = (_c = (_b = (_a = operation.query.definitions.find(function (definition) { return definition.kind === 'OperationDefinition'; })) === null || _a === void 0 ? void 0 : _a.directives) === null || _b === void 0 ? void 0 : _b.find(function (directive) { var _a; return ((_a = directive.name) === null || _a === void 0 ? void 0 : _a.value) === directiveName; })) === null || _c === void 0 ? void 0 : _c.arguments) === null || _d === void 0 ? void 0 : _d.find(function (argument) { var _a; return ((_a = argument.name) === null || _a === void 0 ? void 0 : _a.value) === argumentName; })) === null || _e === void 0 ? void 0 : _e.value) === null || _f === void 0 ? void 0 : _f.value;
};
export var prefixTypenames = function (data, apiName) {
    if (data == null || typeof data !== 'object' || apiName === 'default') {
        return data;
    }
    if (Array.isArray(data)) {
        return data.map(function (item) { return prefixTypenames(item, apiName); });
    }
    var newData = Object.entries(data).reduce(function (ctx, _a) {
        var _b;
        var itemKey = _a[0], item = _a[1];
        return (__assign(__assign({}, ctx), (_b = {}, _b[itemKey] = prefixTypenames(item, apiName), _b)));
    }, {});
    if (data.__typename) {
        return __assign(__assign({}, newData), { __typename: "".concat(apiName, ":").concat(data.__typename) });
    }
    return newData;
};
export var isFunction = function (fn) {
    return fn && {}.toString.call(fn) === '[object Function]';
};
//# sourceMappingURL=utils.js.map